module.exports = __webpack_public_path__ + "static/media/1.4f0636fc.png";